import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'saving': false,
  'creating': false,
  'isOpen': false,
  'selectedOrder': '',
  'steps': [],
};

export const trackingSchedule = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.SELECT_ORDER_FOR_TRACKING_SCHEDULE]: (state, action) => ({
      ...state,
      'isOpen': !!action.payload,
      'selectedOrder': action.payload,
    }),
    [ActionTypes.GET_ORDER_TRACKING_SCHEDULE_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_ORDER_TRACKING_SCHEDULE_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'steps': action.response.data,
    }),
    [ActionTypes.GET_ORDER_TRACKING_SCHEDULE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'steps': [],
    }),
    [ActionTypes.UPDATE_ORDER_TRACKING_STEP_REQUEST]: (state, action) => ({
      ...state,
      'creating': true,
    }),
    [ActionTypes.UPDATE_ORDER_TRACKING_STEP_SUCCESS]: (state, action) => ({
      ...state,
      'creating': false,
    }),
    [ActionTypes.UPDATE_ORDER_TRACKING_STEP_FAILED]: (state, action) => ({
      ...state,
      'creating': false,
    }),
  })(state, action);
};
